import {type ChipColor, type ChipVariant} from '@ds/types';

type StatusChipConfig = {
  variant: ChipVariant;
  color: ChipColor;
};

const STATE_CHIP_MAP: Record<string, StatusChipConfig> = {
  active: {variant: 'soft', color: 'success'},
  inprogress: {variant: 'soft', color: 'success'},
  initiated: {variant: 'soft', color: 'info'},
  waiting: {variant: 'soft', color: 'info'},
  created: {variant: 'soft', color: 'info'},
  paused: {variant: 'soft', color: 'warning'},
  hold: {variant: 'soft', color: 'warning'},
  done: {variant: 'soft', color: 'default'},
  deleted: {variant: 'soft', color: 'default'}
};

export function getStatusChipProps(state?: string, hold = false): StatusChipConfig {
  if (hold) {
    return {variant: 'soft', color: 'warning'};
  }

  if (!state) {
    return {variant: 'soft', color: 'default'};
  }

  return STATE_CHIP_MAP[state] ?? {variant: 'soft', color: 'default'};
}
